<template lang="pug">
#empresa-bloco-inserir-contrato-originacao-planilha
    el-card(:body-style='{ padding: "20px" }')
        .bloco-inserir-contrato-originacao-planilha__linha
            .bloco-inserir-contrato-originacao-planilha__upload
                el-upload(
                    action='#',
                    :auto-upload='false',
                    :on-change='enviarPlanilha',
                    :on-exceed='onExceed',
                    :file-list='fileList',
                    :limit='1',
                    drag,
                    ref='uploadPlanilhaContratoOriginacao'
                )
                    i.el-icon-upload
                    .el-upload__text {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaPlanilha.informativoArrasteAqui') }} <em>{{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaPlanilha.informativoCliqueAqui') }}</em>

                .bloco-card-inserir-dados-planilha__conteudo__bloco__buttons
                    span.btn-download(@click='downloadPlanilhaExemplo()')
                        i.mdi.mdi-download
                        span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaPlanilha.baixarModeloPlanilha') }}
</template>

<script>
import ContratoOriginacaoServiceEmpresa from '@/services/ContratoOriginacaoServiceEmpresa';
import { connect, subscribe, disconnect } from '@/utils/websocket';
import { mapGetters } from 'vuex';

export default {
    name: 'EmpresaBlocoUploadVerificacao',

    data() {
        return {
            fileList: [],
            dadosLote: null
        };
    },
    computed: {
        ...mapGetters(['usuarioLogado'])
    },
    mounted() {
        this.conectarCanalNotificacaoProcessamento();
    },
    beforeDestroy() {
        disconnect();
    },
    methods: {
        onExceed() {
            this.$notify.warning({
                message: this.$t(
                    'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaPlanilha.informacaoUpload.limiteArquivo'
                ),
                position: 'top-left'
            });
        },

        async enviarPlanilha(planilha) {
            if (planilha.size > 15000000) {
                this.$notify.warning(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaPlanilha.informacaoUpload.limiteTamanho'
                    )
                );
                this.$refs.uploadPlanilhaContratoOriginacao.clearFiles();
                return false;
            }
            let extension = planilha.name.split('.').pop().toLowerCase();

            if (extension !== 'xlsx') {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaPlanilha.informacaoUpload.erroExtensaoArquivo'
                    )
                );
                this.$refs.uploadPlanilhaContratoOriginacao.clearFiles();
                return false;
            }

            try {
                this.$notify.success(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaPlanilha.informacaoUpload.arquivoSendoEnviado'
                    )
                );
                const { data } =
                    await ContratoOriginacaoServiceEmpresa.uploadPlanilhaVerificacao(
                        planilha
                    );
                const semErro = [];
                const errosColetados = [];

                data.forEach(item => {
                    if (!item.erros) {
                        semErro.push(item);
                    }

                    // Verificar se o item tem array de erros
                    if (item.erros && Array.isArray(item.erros)) {
                        item.erros.forEach(erro => {
                            errosColetados.push({
                                linhas: erro.linhas,
                                campo: erro.campo,
                                erro: erro.erro
                            });
                        });
                    }
                });

                if (semErro.length > 0) {
                    this.$emit('emitTerritoriosVerificados', semErro);
                }

                if (errosColetados.length > 0) {
                    this.$emit('emitErrosUpload', errosColetados);
                }

                this.$notify.success(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaPlanilha.informacaoUpload.arquivoEnviadoComSucesso'
                    )
                );
            } catch {
                this.$notify.success(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaPlanilha.informacaoUpload.erroConectarWs'
                    )
                );
            }
            this.$refs.uploadPlanilhaContratoOriginacao.clearFiles();
        },

        async conectarCanalNotificacaoProcessamento() {
            try {
                await connect();
            } catch {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaPlanilha.informacaoUpload.erroConectarWs'
                    )
                );
                return;
            }

            try {
                subscribe(
                    `${this.usuarioLogado.idKeyCloack}/lote/contrato-originacao/cadastro`,
                    response => {
                        this.dadosLote = JSON.parse(response);
                        this.$notify.success(
                            this.$t(
                                'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaPlanilha.informacaoUpload.processamentoAtualizado'
                            )
                        );
                        this.$emit('atualizarTabelaContratosNaoEnviados');
                    }
                );
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaPlanilha.informacaoUpload.erroExportarPdf'
                    )
                );
                disconnect();
            }
        },

        downloadPlanilhaExemplo() {
            let link = document.createElement('a');
            let linkDownloadPlanilha = this.$t(
                'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaPlanilha.planilhaExemploVerificacao'
            );

            link.setAttribute(
                'download',
                this.$t(
                    'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaPlanilha.planilhaAtributoNome'
                )
            );
            link.href = linkDownloadPlanilha;
            document.body.appendChild(link);
            link.click();
            link.remove();
        }
    }
};
</script>

<style lang="scss">
#empresa-bloco-inserir-contrato-originacao-planilha {
    .bloco-inserir-contrato-originacao-planilha__linha {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .bloco-inserir-contrato-originacao-planilha__campos {
            width: 500px;
            column-count: 2;

            li.obrigatorio::after {
                content: ' *';
                color: #f56c6c;
            }
        }

        .bloco-card-inserir-dados-planilha__conteudo__bloco__buttons {
            display: flex;
            gap: 15px;
            width: 100%;
            justify-content: flex-end;
            align-items: center;
            .btn-download {
                cursor: pointer;
                display: flex;
                gap: 5px;
                font-weight: 600;
                i {
                    font-size: 15px;
                }
                span {
                    text-decoration: underline;
                    color: var(--primary);
                }
            }
        }
    }

    .bloco-inserir-contrato-originacao-mensagem-informativa_texto {
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
        margin-bottom: 20px;
    }

    .bloco-inserir-contrato-originacao-planilha__upload {
        width: 100%;
        .el-icon-upload {
            color: var(--primary);
            font-size: 30px;
        }
        .el-icon-close {
            color: var(--primary);
            font-size: 15px;
        }
    }

    .bloco-inserir-contrato-originacao-planilha-lote__titulo {
        font-size: 16px;
        font-weight: bold;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .bloco-inserir-contrato-originacao-planilha-lote__importada {
        display: inline-block;
        width: 200px;
        white-space: nowrap;
        overflow: hidden !important;
        text-overflow: ellipsis;
        padding-top: 5px;
    }

    .container-dados {
        margin-top: 1rem;
        display: flex;
        flex-wrap: wrap;
        gap: 4rem;
    }

    .bloco-dados {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
    }

    .bloco-inserir-contrato-originacao-planilha-lote__label {
        font-weight: bold;
        color: var(--primary);
    }

    .el-tag,
    button {
        width: fit-content;
    }

    .el-card__body {
        display: flex;
        flex-direction: column;
        gap: 2rem;
    }

    .el-icon-loading {
        font-size: 15px;
        color: var(--primary);
        margin-right: 5px;
    }

    .el-upload-list__item-name [class^='el-icon'] {
        height: 100% !important;
        margin-right: 7px !important;
        color: #909399 !important;
        line-height: inherit !important;
        font-size: 14px !important;
    }

    .el-upload-dragger:hover {
        border-color: var(--primary);
    }

    .el-upload-dragger {
        background-color: #f3f3f3;
    }
}
</style>
